export enum ContractProcedure {
    cprCard = 0,
    cprVisit = 1,
    cprPayment = 2,
    cprFreeze = 3,
    cprProcedure = 4,
    cprSheduke = 5
}